import { AxiosError } from 'axios'
import {
  type QueryFunctionContext,
  useQuery,
  type UseQueryOptions
} from 'react-query'

import useAuth from 'hooks/use-auth'
import { fetchQueryData } from 'hooks/use-gremlin-query'
import {
  getEndpointWithParams,
  validateQueryDependencies
} from 'queries/queries-utils'
import {
  reliabilityTestsQueryKeys,
  type ReliabilityTestsPreviewQueryParams
} from 'queries/reliability-tests/query-keys'
import { type ScenarioPreview } from 'types/api/reliability-tests/preview'

function fetchReliabilityTestPreview({
  queryKey: [baseUrl, params]
}: QueryFunctionContext<
  ReturnType<typeof reliabilityTestsQueryKeys.getPreview>
>) {
  validateQueryDependencies(
    params,
    'in order to fetch reliability test preview'
  )
  const endpointWithParams = getEndpointWithParams(baseUrl, params)
  return fetchQueryData<ScenarioPreview>(endpointWithParams)
}

export function useGetReliabilityTestPreview(
  params?: Omit<ReliabilityTestsPreviewQueryParams, 'teamId'>,
  queryOptions?: Omit<
    UseQueryOptions<ScenarioPreview, AxiosError>,
    'queryKey' | 'queryFn'
  >
) {
  const { currentTeamId } = useAuth()

  return useQuery({
    ...queryOptions,
    queryFn: fetchReliabilityTestPreview,
    ...(params && {
      queryKey: reliabilityTestsQueryKeys.getPreview({
        ...params,
        teamId: currentTeamId
      })
    })
  })
}
